import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const ManBehindPowers = async () => {
  try {
    return await getData(`/website/aboutus/manbehindpower`);
  } catch (error) {
    console.log(error);
  }
};


export const WeFocus = async () => {
  try {
    return await getData(`/website/aboutus/wefocus`);
  } catch (error) {
    console.log(error);
  }
};


export const WhatMakeDifferents = async () => {
  try {
    return await getData(`/website/aboutus/whatmakedifferent`);
  } catch (error) {
    console.log(error);
  }
};


export const WhyWeRanks = async () => {
  try {
    return await getData(`/website/aboutus/whywerank`);
  } catch (error) {
    console.log(error);
  }
};


export const PeopleBehindWorks = async () => {
  try {
    return await getData(`/website/aboutus/peoplebehindwork`);
  } catch (error) {
    console.log(error);
  }
};


export const VisionMissions = async () => {
  try {
    return await getData(`/website/aboutus/visionmission`);
  } catch (error) {
    console.log(error);
  }
};


export const Banners = async () => {
  try {
    return await getData(`/website/aboutus/banner`);
  } catch (error) {
    console.log(error);
  }
};